import useScrollAnimation from '../../../hooks/useScrollAnimation';

import brandImg1 from '../../../utils/images/lightNation.png';
import brandImg2 from '../../../utils/images/ambience-logo.png';
import brandImg3 from '../../../utils/images/Ciana_logo 1.png';
import brandImg4 from '../../../utils/images/google.png';
import brandImg5 from '../../../utils/images/cosmos_logo-black.png';
import brandImg6 from '../../../utils/images/immersive_logo.jpg';
import exploreIcon from '../../../utils/icons/explore-icon.png';
import { Helmet } from 'react-helmet-async';


const SponsorsPage = () => {
  useScrollAnimation();
  return (
    <main className='sponsors-section page-width px-3 overflow-hidden'>
      <Helmet>
          <title>Speakers - Cosmos Conference 2024</title>
          <meta name="description" content="Meet the Sponsors and Partners of Cosmos Conference 2024. Would you like to be a Sponsor or Partner?" />
          <link rel="canonical" href="https://cosmosconference.org/sponsors" />
      </Helmet>

      <section className="speaker_hero-section pt-5 mt-5 py-md-5">
        <h1 className='py-5'>MEET OUR SPONSORS & PARTNERS</h1>
      </section> 

      <section className='my-5 py-0 py-md-5'>
        <h2 className="text-center text-uppercase py-2 py-md-5">Sponsor Us</h2>    

        <div className="brands-section sponsorship-brands d-flex flex-wrap justify-content-center my-3 my-md-5 gap-3 gap-md-5">
          <div className="sponsor-card sponsor-card1 light_nation-logo js-scroll slide-left">
              <img src={brandImg1} alt="brand-image" width='100%' />
          </div>
          {/* <div className="sponsor-card sponsor-card2 js-scroll fade-in">
              <img src={brandImg5} alt="brand-image" width='100%' />
          </div> */}
          <div className="sponsor-card sponsor-card3 js-scroll fade-in">
              <img src={brandImg3} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card4 js-scroll slide-right">
              <img src={brandImg4} alt="brand-image" width='100%' />
          </div>
        </div>


        {/* <div className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
          <div className="sponsor-card sponsor-card1 js-scroll slide-left">
              <img src={brandImg4} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card2 js-scroll fade-in">
              <img src={brandImg3} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card3 js-scroll fade-in">
              <img src={brandImg2} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card4 js-scroll slide-right">
              <img src={brandImg1} alt="brand-image" width='100%' />
          </div>
        </div> */}

        {/* <div className="brands-section sponsorship-brands d-flex justify-content-center my-3 my-md-5">
          <div className="sponsor-card sponsor-card5 js-scroll fade-in-bottom">
              <img src={brandImg5} alt="brand-image" width='100%' />
          </div>
        </div> */}

        {/* <div className="d-none d-md-block">
          <section className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
            <div className="sponsor-card sponsor-card1 js-scroll slide-left">
                <img src={brandImg1} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card2 js-scroll fade-in">
                <img src={brandImg2} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card3 js-scroll fade-in">
                <img src={brandImg3} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card4 js-scroll slide-right">
                <img src={brandImg4} alt="brand-image" width='100%' />
            </div>
          </section>

          <section className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
            <div className="sponsor-card sponsor-card1 js-scroll slide-left">
                <img src={brandImg1} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card2 js-scroll fade-in">
                <img src={brandImg2} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card3 js-scroll fade-in">
                <img src={brandImg3} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card4 js-scroll slide-right">
                <img src={brandImg4} alt="brand-image" width='100%' />
            </div>
          </section>
        </div> */}

        <section className='d-flex justify-content-md-end justify-content-center align-items-center my-4 my-md-5 mb-5 pb-0 pb-md-5'>
            <a href='https://forms.gle/fjFbG7SC6E4ijkJx7' rel="noopener noreferrer"  target='_blank' className='customBtn text-uppercase'> <span>Sponsor Us</span> <img src={exploreIcon} alt="" /></a>
        </section>
      </section>

      <section className='my-5 py-0 py-md-5'>
        <h2 className="text-center text-uppercase py-2 py-md-5 mt-5">Partner With Us</h2>    

        <div className="brands-section sponsorship-brands d-flex flex-wrap justify-content-center my-3 my-md-5 gap-3 gap-md-5">
          <div className="sponsor-card sponsor-card2 js-scroll slide-left">
              <img src={brandImg5} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card3 js-scroll fade-in">
              <img src={brandImg3} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card1 js-scroll slide-right">
              <img src={brandImg2} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card4 js-scroll slide-right">
              <img src={brandImg6} alt="brand-image" width='100%' height='100%' />
          </div>
        </div>


        {/* <div className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
          <div className="sponsor-card sponsor-card1 js-scroll slide-left">
              <img src={brandImg4} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card2 js-scroll fade-in">
              <img src={brandImg3} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card3 js-scroll fade-in">
              <img src={brandImg2} alt="brand-image" width='100%' />
          </div>
          <div className="sponsor-card sponsor-card4 js-scroll slide-right">
              <img src={brandImg1} alt="brand-image" width='100%' />
          </div>
        </div> */}

        {/* <div className="brands-section sponsorship-brands d-flex justify-content-center my-3 my-md-5">
          <div className="sponsor-card sponsor-card5 js-scroll fade-in-bottom">
              <img src={brandImg5} alt="brand-image" width='100%' />
          </div>
        </div> */}

        {/* <div className="d-none d-md-block">
          <section className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
            <div className="sponsor-card sponsor-card1 js-scroll slide-left">
                <img src={brandImg1} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card2 js-scroll fade-in">
                <img src={brandImg2} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card3 js-scroll fade-in">
                <img src={brandImg3} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card4 js-scroll slide-right">
                <img src={brandImg4} alt="brand-image" width='100%' />
            </div>
          </section>

          <section className="brands-section sponsorship-brands d-flex flex-wrap justify-content-md-between justify-content-center my-3 my-md-5 gap-3 gap-md-1">
            <div className="sponsor-card sponsor-card1 js-scroll slide-left">
                <img src={brandImg1} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card2 js-scroll fade-in">
                <img src={brandImg2} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card3 js-scroll fade-in">
                <img src={brandImg3} alt="brand-image" width='100%' />
            </div>
            <div className="sponsor-card sponsor-card4 js-scroll slide-right">
                <img src={brandImg4} alt="brand-image" width='100%' />
            </div>
          </section>
        </div> */}

        <section className='d-flex justify-content-md-end justify-content-center align-items-center my-4 my-md-5 mb-5 pb-0 pb-md-5'>
            <a href='https://forms.gle/fjFbG7SC6E4ijkJx7' rel="noopener noreferrer"  target='_blank' className='customBtn text-uppercase'> <span>Partner With Us</span> <img src={exploreIcon} alt="" /></a>
        </section>
      </section>
    </main>
  )
}

export default SponsorsPage